<template>
  <div class="modal fade" id="save-c-TemplateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Vorlage speichern</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form v-on:submit.prevent="saveConstructionTemplate">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <input class="form-control" placeholder="Bezeichnung" name="Bezeichnung" v-model="templateName" required>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="dokubtns text-right border-0">
            <span class="btninner">
              <button type="reset" class="btn btn-red" data-dismiss="modal">
                abbrechen
              </button>
              <button type="submit" class="btn btn-blue">
                 {{ $t('save') }}
              </button>
            </span>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      templateName: '',
    }
  },
  mounted () {

  },
  computed: {
    fieldsGroups: {
      get(){
        return this.$store.state.appSettings.fieldsGroups
      },
      set(groups){
        this.$store.commit("setFieldsGroups",groups)
      }
    },
    project(){
      return this.$store.state.appSettings.project
    },
    userId () {
      return this.$store.state.projects.user.pduserid
    }
  },

  methods: {
    async saveConstructionTemplate(){
      let user_id = this.project.customer_id
      $('#save-c-TemplateModal').modal('toggle');
      this.$store.commit('settingsModuleSetLoading',true);
      let params = {
        constructionreport: 1,
        crtemplateid: 0,
        customer_id: user_id,
        groups: this.fieldsGroups,
        is_default: 0,
        name: this.templateName,
        shifts: this.project.shifts,
        show_misc: 1,
        staffdata: 1,
        staffparams: [],
        unit_humidity: 1,
        unit_speed: 1,
        unit_temperature: 1,
        use_weatherdb: 1,
        weather_zipcode: "",
        weatherdata: 1,
        _explicitType: "com\\projectdocu\\CRTemplateVO"
      }
      await this.$store.dispatch('saveConstructionSettingsTemplate', [ params ])
      this.$store.commit('settingsModuleSetLoading',false);
    }
  }
}
</script>

<style scoped>
#save-c-TemplateModal .modal-dialog {
  max-width: 30%;
}

#save-c-TemplateModal select, #templateModal input {
  font-size: 1.04rem;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/SaveConstructionTemplate.vue